import { settingsApi } from "./settings.api";

export const { useGetSettingsByCompanyQuery, useToggleSettingsToleranceMutation, useLazyGetSettingsByCompanyQuery } = settingsApi;
